'use client'

import Link from 'next/link'
import type { MouseEvent } from 'react'

import {
  DiscountBadge,
  Overview,
  PriceDetail,
  RoomThumbnail,
  SuperHostBadge,
  TFavoriteRoom,
} from '@/entities/room'
import { LikeButton } from '@/features/toggle-favorite-room'
import { Icon } from '@/shared/ui'

type Props = {
  room: TFavoriteRoom
  deleteButton?: boolean
  onDelete?: (roomId: number) => void
  onLike?: () => void
  onUnlike?: () => void
}

export const RoomItem = ({
  room,
  deleteButton = false,
  onDelete,
  onLike,
  onUnlike,
}: Props) => {
  const handleDeleteButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    event.preventDefault()

    onDelete?.(room.rid)
  }

  return (
    <Link href={`/guest/room/${room.rid}`} className="flex items-center">
      <div className="relative mr-6">
        <LikeButton
          roomId={room.rid}
          like={room.like}
          className="absolute top-0 right-0 z-[1]"
          onLike={onLike}
          onUnlike={onUnlike}
        />
        <RoomThumbnail
          src={room.picMain}
          alt={room.roomName}
          rounded
          size={200}
          ratio="1:1"
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8VA8AAkkBY8DEq9wAAAAASUVORK5CYII="
        />
      </div>
      <div className="grow">
        {room.isSuperHost && (
          <SuperHostBadge className="mb-2 rounded-xs shadow-[0_1px_3px_0_rgba(0,0,0,0.25)]" />
        )}
        <Overview
          size="large"
          province={room.province}
          town={room.town}
          propertyType={room.propertyType}
          roomName={room.roomName}
          roomCnt={room.roomCnt}
          bathroomCnt={room.bathroomCnt}
          cookroomCnt={room.cookroomCnt}
          sittingroomCnt={room.sittingroomCnt}
          usingFee={room.usingFee}
          mgmtFee={room.mgmtFee}
        />
        <PriceDetail usingFee={room.usingFee} mgmtFee={room.mgmtFee} />
        <DiscountBadge
          percent={room.longtermDiscountPer}
          amount={room.earlyDiscountAmount}
          className="w-[266px]"
        />
      </div>
      {deleteButton && (
        <button
          className="shrink-0 cursor-pointer self-start"
          onClick={handleDeleteButtonClick}
        >
          <Icon
            name="close"
            size={24}
            strokeWidth={1.5}
            className="text-gray-400"
          />
          <span className="sr-only">삭제하기</span>
        </button>
      )}
    </Link>
  )
}
